import React, {Component} from "react";
import {Button, Form} from "react-bootstrap";
import ContentWrapper from '../Layout/ContentWrapper';
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import {API_ROOT} from '../../api-config';
import Swal from 'sweetalert2'

class ImportLCBO extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: null, // the uploaded CSV file
            data: null, // the parsed data as an array
        };
        this.inputRef = React.createRef(); // a reference to the file input element
    }

    // a method to handle the file change event
    handleFileChange = (e) => {
        const file = e.target.files[0]; // get the file object
        if (file) {
            this.setState({
                file: file,
            });
        }
    };


    // a method to handle the file upload button click
    handleUpload = () => {
        const {file} = this.state;
        if (!file) return alert("Please select a file");

        const reader = new FileReader();
        reader.onload = (e) => {
            let text = e.target.result;
            text = text.replace(/^\uFEFF/, "");          // remove BOM if present
            const lines = text.split(/\r?\n/);           // handle CRLF and LF

            // regex: captures quoted fields OR zero-or-more non-commas (so empty fields are captured)
            const cellRe = /("(?:[^"\\]|\\.)*"|[^,]*)(?:,|$)/g;

            const parseLine = (line) => {
                const values = [];
                let m;
                // use a fresh regexp (cellRe with g) each call; so create local re to reset lastIndex
                const re = new RegExp(cellRe);
                while ((m = re.exec(line)) !== null) {
                    let val = m[1] || ""; // matched quoted or unquoted (may be empty)
                    // if quoted, strip outer quotes and unescape double quotes per CSV rules
                    if (val.length >= 2 && val[0] === '"' && val[val.length - 1] === '"') {
                        val = val.slice(1, -1).replace(/""/g, '"');
                    }
                    // remove stray CR that can appear on Windows lines
                    val = val.replace(/\r$/, "");
                    values.push(val);
                    // break if re is stuck (safety)
                    if (re.lastIndex === 0) break;
                    // ensure progress on empty trailing fields:
                    if (re.lastIndex >= line.length) break;
                }
                return values;
            };

            if (lines.length === 0) return;

            const headers = parseLine(lines[0]).map(h => h.replace(/\r/g, "").replace(/'/g, "").trim());
            const rows = lines.slice(1);

            const array = rows
                .map(row => {
                    if (!row || !row.trim()) return null; // skip blank lines
                    const values = parseLine(row);
                    const obj = {};
                    headers.forEach((header, i) => {
                        obj[header] = typeof values[i] !== "undefined" ? values[i] : "";
                    });
                    return obj;
                })
                .filter(Boolean);

            // send to backend
            axios.defaults.withCredentials = true;
            axios.post(API_ROOT + "/import_lcbo/", array)
                .then(response => {
                    if (response.data.error) {
                        Swal("Error", response.data.error + ". " + response.data.payments_added + " orders imported.", "error");
                    } else {
                        Swal("Done", response.data.payments_added + " orders imported.", "success");
                    }
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 401) {
                            this.props.userSignOut();
                        } else {
                            Swal("Error", error.response.data.Message, "error");
                            this.setState({processing: false});
                        }
                    }
                });
        };

        reader.readAsText(file);

    };


    render() {
        return (
            <ContentWrapper>
                <div className="content-heading">
                    Import LCBO Orders
                </div>
                <div className={(this.state.loading ? "card card-default whirl traditional" : "card card-default")}>
                    <div className="card-body">
                        Use this page to import the LCBO orders

                        <div className="pt-3 pb-2">
                            <input
                                type="file"
                                accept=".csv"
                                ref={this.inputRef}
                                onChange={this.handleFileChange}
                                className="form-controol"
                            />
                        </div>
                        <button onClick={this.handleUpload} className="btn btn-primary">Upload</button>
                    </div>
                </div>
            </ContentWrapper>
        );
    }
}

export default ImportLCBO;